import { PageToolbar } from '@app/components/page-toolbar/PageToolbar';
import { reportNameMessages } from '@app/modules/audit/modules/reports/constants';
import { ReportDefinitionListPanel } from '@app/modules/audit/modules/reports/definitions/list/ReportDefinitionListPanel';
import {
  ADMIN_AUDIT_DEFAULT_TEMPLATE_TYPE,
  adminAuditPaths,
} from '@app/modules/audit/routing/admin-audit-paths';
import { ChipItem, ChipNavigationMui } from '@mi-front/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { Page } from '../../../../components/page/Page';
import { AuditIcon } from '../../components/AuditIcon';
import { AUDIT_TEMPLATE_REPORT_TYPES } from './audit-template-report-types';
import { AuditTemplatesCreateAction } from './AuditTemplatesCreateAction';

/**
 * Admin plantillas page: chip navigation across report types with each type’s template list.
 */
export function AuditTemplatesPage() {
  const { $t } = useIntl();
  const title = $t({
    id: 'audit.reportDefinitions.templatesTitle',
    defaultMessage: 'Plantillas',
  });

  const chips: ChipItem[] = AUDIT_TEMPLATE_REPORT_TYPES.map((reportType) => ({
    value: reportType,
    label: <FormattedMessage {...reportNameMessages[reportType]} />,
    content: (
      <Page.Content key={reportType}>
        <ReportDefinitionListPanel reportType={reportType} />
      </Page.Content>
    ),
  }));

  return (
    <Page htmlTitle={title}>
      <Page.Header icon={<AuditIcon />} title={title} actions={<AuditTemplatesCreateAction />} />
      <ChipNavigationMui
        pathBase={adminAuditPaths.templates()}
        pathParamName="reportType"
        defaultActiveChip={ADMIN_AUDIT_DEFAULT_TEMPLATE_TYPE}
        Wrapper={PageToolbar}
        chips={chips}
      />
    </Page>
  );
}
